import { useCallback, useState, useEffect } from 'react'
import styled from 'styled-components'
import { Card } from 'antd'
import { FirebaseApp } from 'firebase/app'
import { isMobile } from '../constants'
import {
  collection,
  getDocs,
  getFirestore,
  query,
} from 'firebase/firestore/lite'

type Props = {
  firebaseApp: FirebaseApp
}

const AdminPanel = ({ firebaseApp }: Props) => {
  //const [totalUsers, setTotalUsers] = useState(undefined)
  const [billingUsers, setBillingUsers] = useState(undefined)

  const billingCall = useCallback(async () => {
    const db = getFirestore(firebaseApp)
    const citiesCol = collection(db, 'billing')
    const q = query(citiesCol)
    const querySnapshot = await (await getDocs(q)).size

    return querySnapshot
  }, [firebaseApp])

  const makeBillingGet = useCallback(() => {
    billingCall().then(async (data: any) => {
      setBillingUsers(data)
    })
  }, [billingCall])

  useEffect(() => {
    if (!billingUsers) {
      makeBillingGet()
    }
  }, [billingUsers, makeBillingGet])

  return (
    <Container>
      <Card
        type="inner"
        title="Billing Users"
        style={{
          marginBottom: '15px',
          fontWeight: 'bold',
          width: isMobile ? '100%' : '800px',
        }}
      >
        {billingUsers}
      </Card>
    </Container>
  )
}

export default AdminPanel

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 100%;
  padding: 50px;

  @media (max-width: 768px) {
    padding: 5px;
  }
`
